import { stylesFieldForms } from './../styles'
import { FieldsTipoParametroTransformacaoApiProps } from './FieldsTipoParametroTransformacaoApi.View'

export function fieldsTipoParametroTransformacaoApiIO({ isCondicao, indexItensRegraForm }: FieldsTipoParametroTransformacaoApiProps) {
  const verificarCondicao = (campo: string) => {
    return isCondicao
      ? (`condicoes.${indexItensRegraForm}.parametro.${campo}` as `string.0.string.string`)
      : (`acoes.${indexItensRegraForm}.parametro.${campo}` as `string.0.string.string`)
  }

  return {
    styles: stylesFieldForms,
    verificarCondicao
  }
}

export type FieldsTipoParametroTransformacaoApiIO = ReturnType<typeof fieldsTipoParametroTransformacaoApiIO>
